export enum CompanyCreationExceptionCodes {
  STATE_TRANSITION_NOT_ALLOWED = 'STATE_TRANSITION_NOT_ALLOWED',
  NO_LAWYER_FOUND = 'NO_LAWYER_FOUND',
  NO_LAWYER_PICTURE_FOUND = 'NO_LAWYER_PICTURE_FOUND',
  NO_SIGNED_CONTRACT_FOUND = 'NO_SIGNED_CONTRACT_FOUND',
  NO_PERMISSION = 'NO_PERMISSION',
  EMAIL_SENDING_ERROR = 'EMAIL_SENDING_ERROR',
  DOCUMENT_NOT_FOUND = 'DOCUMENT_NOT_FOUND',
  TAX_NUMBER_EDITING_NOT_ALLOWED = 'TAX_NUMBER_EDITING_NOT_ALLOWED',
  EDITING_NOT_ALLOWED_BY_CUSTOMER_SERVICE = 'EDITING_NOT_ALLOWED_BY_CUSTOMER_SERVICE',
  FOUNDATION_DOCUMENT_XML_ERROR = 'FOUNDATION_DOCUMENT_XML_ERROR',
}
